import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    marginLeft: "24px",
    borderRadius: "8px !important",
  },
  paper: {
    margin: "12px 24px",
    "&.MuiPaper-rounded": {
      position: "relative",
    },
  },
  icon: {
    fontSize: 24,
    cursor: "pointer",
    color: theme.palette.secondary.main,
    minWidth: theme.spacing(12),
  },
}));
